import type { Product } from "@thenounproject/lingo-core";
import type { ProductDraft } from "@features/products/hooks/useProductDraft";
import { createAction } from "@redux/actions/actionCreators";

const [useInitProduct, initProduct] = createAction<{
  product: Product;
  spaceId: number;
  draft: ProductDraft | null;
}>("product/init");

export default useInitProduct;
export { initProduct };
